<pwj-filters-dialog
  titleId="solutions-people-filters-dialog-title"
  (closed)="close()"
  (applied)="applyFilters()"
  (removed)="removeFilters()">
  <pwj-solutions-people-filters [layoutVariant]="'dialog'" />
</pwj-filters-dialog>
